module.exports = __webpack_public_path__ + "static/media/icon_4.3476d409.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageTextCheck/icon_4.svg
// module id = 598
// module chunks = 0